import { render } from "./AddPaymentModal.vue?vue&type=template&id=5fba4858&ts=true"
import script from "./AddPaymentModal.vue?vue&type=script&lang=ts"
export * from "./AddPaymentModal.vue?vue&type=script&lang=ts"

import "./AddPaymentModal.vue?vue&type=style&index=0&id=5fba4858&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__